var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZubyR0H6Xqeujxx4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 288,
    style: {
      fill: "#B6C1CE"
    },
    width: 48,
    height: 56
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECECEC"
    },
    d: "M304,88v-6.464C304,40.928,271.072,8,230.464,8l0,0c-19.504,0-38.208,7.744-52,21.536l-4.808,4.808 C170.032,37.968,165.12,40,160,40l0,0c-5.12,0-10.032-2.032-13.656-5.656l-4.808-4.808C127.744,15.744,109.04,8,89.544,8h-8 C40.928,8,8,40.928,8,81.536l0,0c0,46.712,6.984,93.16,20.72,137.808l38.04,123.624C69.872,353.088,79.232,360,89.824,360h0.672 c11.288,0,21.064-7.824,23.536-18.832l26.456-117.56C142.544,214.48,150.648,208,160,208l0,0c9.352,0,17.456,6.48,19.512,15.608 l26.456,117.56c2.48,11.008,12.256,18.832,23.544,18.832l0,0c10.912,0,20.464-7.32,23.296-17.856L272,270.856L304,88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6C1CE"
    },
    d: "M160,192c-53.368,0-103.104-11.344-145.112-30.872c3.384,19.648,7.952,39.104,13.832,58.216 l38.04,123.624C69.872,353.088,79.232,360,89.824,360h0.672c11.288,0,21.064-7.824,23.536-18.832l26.456-117.56 C142.544,214.48,150.648,208,160,208s17.456,6.48,19.512,15.608l26.456,117.56c2.48,11.008,12.256,18.832,23.544,18.832 c10.912,0,20.464-7.32,23.296-17.856L272,270.856l18.056-103.16C251.416,183.184,207.112,192,160,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6C1CE"
    },
    d: "M224,192c0,39.616,16.008,75.48,41.896,101.52L272,270.856L304,88v-6.464 c0-5.992-0.792-11.784-2.144-17.36C255.632,88.152,224,136.336,224,192z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECECEC"
    },
    cx: 368,
    cy: 192,
    r: 120
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#39C3FC"
    },
    cx: 368,
    cy: 192,
    r: 88
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFEAA7"
    },
    points: "416,176 384,176 384,144 352,144 352,176 320,176 320,208 352,208 352,240 384,240 384,208 416,208 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EABD8C"
    },
    d: "M392,344v120c0,13.256-10.744,24-24,24l0,0c-13.256,0-24-10.744-24-24V344H392z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 344,
    style: {
      fill: "#D3A06C"
    },
    width: 48,
    height: 64
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496,192c0-70.576-57.424-128-128-128c-20.184,0-39.224,4.824-56.224,13.184C309.496,34.256,273.952,0,230.464,0 c-21.784,0-42.256,8.48-57.656,23.88L168,28.68c-4.248,4.248-11.76,4.256-15.992,0l-4.816-4.808C131.8,8.48,111.32,0,89.536,0h-8 C36.576,0,0,36.576,0,81.536c0,47.552,7.088,94.704,21.072,140.16l38.04,123.632C63.288,358.888,75.632,368,90.496,368 c15.136,0,28.024-10.312,31.344-25.072l26.456-117.56c1.232-5.52,6.048-9.368,11.704-9.368s10.472,3.848,11.712,9.368 l26.456,117.552c3.32,14.768,16.208,25.08,31.336,25.08c14.496,0,27.248-9.776,31.024-23.776l16.712-62.072 c15.96,16.064,36.184,27.792,58.752,33.64V336h-16v16h16v16h-16v16h16v80c0,17.648,14.352,32,32,32s32-14.352,32-32v-80h16v-16h-16 v-16h16v-16h-16v-20.216C455.112,301.52,496,251.512,496,192z M264.272,268.776l-19.192,71.296 c-1.896,7.024-8.296,11.928-15.576,11.928c-7.592,0-14.072-5.176-15.736-12.592l-26.456-117.56C184.424,208.984,173.184,200,160,200 s-24.424,8.984-27.32,21.848l-26.456,117.56C104.56,346.824,98.088,352,89.824,352c-7.128,0-13.32-4.576-15.416-11.384 l-38.04-123.624C22.848,173.064,16,127.496,16,81.536c0-12.208,3.416-23.616,9.256-33.408C42.312,48.808,56,62.784,56,80v7.28 c0,17.312,9.168,32.872,24,41.44V160h16v-23.056l12.424,6.208l7.16-14.312l-25.888-12.944C78.776,110.448,72,99.48,72,87.28V80 c0-22.032-14.936-40.6-35.208-46.216C48.52,22.792,64.232,16,81.536,16h8c17.504,0,33.968,6.816,46.344,19.192L140.696,40 c5.08,5.08,12.12,8,19.304,8c7.288,0,14.152-2.84,19.312-8l4.808-4.808C196.496,22.816,212.952,16,230.464,16 C266.6,16,296,45.4,296,81.536v4.712c-33.776,23.072-56,61.856-56,105.744c0,29.056,9.84,55.792,26.216,77.296L264.272,268.776z M256,192c0-61.76,50.24-112,112-112s112,50.24,112,112s-50.24,112-112,112S256,253.76,256,192z M384,464c0,8.824-7.176,16-16,16 s-16-7.176-16-16v-80h32V464z M384,368h-32v-16h32V368z M384,336h-32v-17.112c5.256,0.664,10.568,1.112,16,1.112 s10.744-0.448,16-1.112V336z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392,248v-32h32v-48h-32v-32h-48v32h-32v48h32v32H392z M328,200v-16h32v-32h16v32h32v16h-32v32h-16v-32H328z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.56,65.344c-4.592,3.064-10.528,3.064-15.128,0c-9.984-6.656-22.888-6.656-32.872,0l-12,8l8.872,13.312l12-8 c4.592-3.064,10.528-3.064,15.128,0c9.984,6.656,22.888,6.656,32.872,0c4.592-3.064,10.528-3.064,15.128,0l12,8l8.872-13.312l-12-8 C190.456,58.688,177.544,58.688,167.56,65.344z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M431.168,264.288L420.64,252.24C406.072,264.984,387.376,272,368,272c-44.112,0-80-35.888-80-80s35.888-80,80-80 s80,35.888,80,80c0,18.576-6.504,36.672-18.328,50.96L442,253.152c14.184-17.144,22-38.864,22-61.152c0-52.936-43.064-96-96-96 s-96,43.064-96,96s43.064,96,96,96C391.248,288,413.688,279.576,431.168,264.288z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZubyR0H6Xqeujxx4);
export default __webpack_public_path__ + "static/media/zuby_r0h6xqeujxx4.a4884245d2361c498e7d8dfa455e25b6.svg";
export { ForwardRef as ReactComponent };